import React from "react";
import { useSelector } from "react-redux";
import UrlInput from "../../../../ui/urlInput/UrlInput";

const UrlField = ({ value, onChange }) => {
    const { texts } = useSelector((state) => state.translate);

    return (
        <UrlInput
            label={texts.toolUrl}
            value={value}
            onChange={onChange}
            placeholder="https://example.com"
        />
    );
};

export default UrlField;
